module.exports = __webpack_public_path__ + "static/media/loadingGif2.0139ef45.gif";